export default "__VITE_ASSET__DlnbLHzS__"